(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-sort-search-table", ["React"], factory);
	else if(typeof exports === 'object')
		exports["react-sort-search-table"] = factory(require("react"));
	else
		root["react-sort-search-table"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__798__) {
return 